// extracted by mini-css-extract-plugin
module.exports = {"CreditScoreComments":"loanPurpose_CreditScoreComments__38iTf","Title":"loanPurpose_Title__39FS_","ActionBar":"loanPurpose_ActionBar__-VAAM"};